import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M39.84 24.375C39.84 23.205 39.735 22.08 39.54 21H24V27.39H32.88C32.49 29.445 31.32 31.185 29.565 32.355V36.51H34.92C38.04 33.63 39.84 29.4 39.84 24.375Z",
      fill: "#4285F4"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 40.4999C28.455 40.4999 32.19 39.0299 34.92 36.5099L29.565 32.3549C28.095 33.3449 26.22 33.9449 24 33.9449C19.71 33.9449 16.065 31.0499 14.76 27.1499H9.27V31.4099C11.985 36.7949 17.55 40.4999 24 40.4999Z",
      fill: "#34A853"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.76 27.135C14.43 26.145 14.235 25.095 14.235 24C14.235 22.905 14.43 21.855 14.76 20.865V16.605H9.27C8.145 18.825 7.5 21.33 7.5 24C7.5 26.67 8.145 29.175 9.27 31.395L13.545 28.065L14.76 27.135Z",
      fill: "#FBBC05"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 14.07C26.43 14.07 28.59 14.91 30.315 16.53L35.04 11.805C32.175 9.135 28.455 7.5 24 7.5C17.55 7.5 11.985 11.205 9.27 16.605L14.76 20.865C16.065 16.965 19.71 14.07 24 14.07Z",
      fill: "#EA4335"
    }, null, -1)
  ])))
}
export default { render: render }